export const Roles = {
  sa: "sa",
  admin: "admin",
  teacher: "teacher",
  student: "student",
};
